import { useCallback, useEffect, useMemo, useReducer } from 'react';
import { useSelector } from 'react-redux';
import { getFlights, getHoveredFlight, getLastUpdate, getSelectedAirport, getSelectedFlight } from '../../store/flightStatus/selectors';
import { reducer } from './state';
import { getLocale } from '../../../../utils';
import { compareAsc, parse } from 'date-fns';
import { SERVER_DATE_FORMAT } from '../../services/constants';
import { useToggleable } from '../../../../hooks';
import { debounce } from '@mui/material';
const SCROLLBAR_HIDE_LIMIT = 8;
export const useFlightStatusUIState = () => {
    const flights = useSelector(getFlights);
    const lastUpdate = useSelector(getLastUpdate);
    const selectedAirport = useSelector(getSelectedAirport);
    const selectedFlight = useSelector(getSelectedFlight);
    const hoveredFlight = useSelector(getHoveredFlight);
    const mobileFilters = useToggleable(false);
    const locale = getLocale();
    const [state, dispatch] = useReducer(reducer, {
        flights: [],
        collapseOpen: false,
        filteredFlights: [],
        input: '',
        filterType: 'departure',
        drawerOpen: false
    });
    useEffect(() => {
        dispatch({
            type: 'setFlights',
            payload: flights
        });
    }, [flights.length]);
    // useEffect(() => {
    // 	console.log(state);
    // }, [state]);
    useEffect(() => {
        dispatch({
            type: 'setSelectedAirport',
            payload: selectedAirport
        });
    }, [selectedAirport]);
    useEffect(() => {
        dispatch({
            type: 'setSelectedFlight',
            payload: selectedFlight
        });
    }, [selectedFlight]);
    const onInputChange = useCallback(e => {
        dispatch({
            type: 'setInput',
            payload: e.target.value
        });
    }, [state]);
    const openedFlightId = useMemo(() => {
        if (selectedFlight) {
            return selectedFlight.uniqueId;
        }
        else if (hoveredFlight) {
            return hoveredFlight.uniqueId;
        }
        else if (state.filteredFlights.length === 1) {
            return state.filteredFlights[0].uniqueId;
        }
        else {
            return null;
        }
    }, [selectedFlight, state.filteredFlights, hoveredFlight]);
    const handleOpenCollapse = useCallback(() => {
        dispatch({
            type: 'setCollapseOpen',
            payload: true
        });
    }, [state.collapseOpen]);
    const handleOnClickOutside = useCallback(() => {
        if (state.drawerOpen) {
            dispatch({
                type: 'setDrawerOpen',
                payload: false
            });
        }
    }, [state.drawerOpen, selectedFlight, selectedAirport]);
    useEffect(() => {
        dispatch({
            type: 'setDrawerOpen',
            payload: Boolean(state.input || selectedFlight || selectedAirport)
        });
    }, [state.input, selectedAirport, selectedFlight]);
    const handleClearInput = useCallback(() => {
        dispatch({
            type: 'setInput',
            payload: ''
        });
    }, [state]);
    const handleChangeFilter = useCallback((filter) => {
        dispatch({
            type: 'setFilterType',
            payload: filter
        });
    }, [state.filterType]);
    const isNeedToRenderDelimiter = (currentFlight, index) => {
        const nextFlight = state.filteredFlights[index + 1];
        if (!nextFlight) {
            return false;
        }
        const currentFlightDate = parse(currentFlight.departure.date, SERVER_DATE_FORMAT, new Date());
        const nextFlightDate = parse(nextFlight.departure.date, SERVER_DATE_FORMAT, new Date());
        return compareAsc(currentFlightDate, nextFlightDate) !== 0;
    };
    return {
        locale,
        isDrawerOpen: state.drawerOpen,
        filteredFlights: state.filteredFlights,
        onInputChange: debounce(onInputChange, 200),
        handleClearInput,
        inputValue: state.input,
        openCollapse: handleOpenCollapse,
        isCollapseOpen: state.collapseOpen,
        isScrollBarVisible: state.filteredFlights.length > SCROLLBAR_HIDE_LIMIT,
        isNeedToRenderDelimiter,
        handleChangeFilter,
        isNeedToRenderFilters: true,
        currentFilter: state.filterType,
        handleOnClickOutside,
        openedFlightId,
        lastUpdate,
        mobileFilters
    };
};
